import React from 'react';

export const securityMeasuresMessages = {
  value: 'Security Measures',
  list: [
    {
      value: (
        <>
          Glints will use its reasonable endeavors to ensure that its officers,
          directors, employees, agents and/or contractors exercise their
          prudence and due diligence in handling the personal data submitted by
          Job Seeker and that access to and processing of the personal data by
          such persons is on a “need-to-know” and “need-to-use” basis. Glints
          will use its reasonable endeavors to protect Job Seekers’ personal
          data against any unauthorized or accidental access, processing or
          erasure of the personal data.
        </>
      ),
    },
  ],
};
